/**
 * Tracks a coupon the shopper explicitly applied during this browser session,
 * so we can tell server-persisted cart coupons apart from "auto" state on checkout load.
 */

const KEY = 'sheenwear_checkout_explicit_coupon';

export function checkoutExplicitCouponMatchesCart(cart) {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw || !cart?._id || !cart?.coupon?.code) return false;
    const s = JSON.parse(raw);
    const code = String(cart.coupon.code).trim().toLowerCase();
    return String(s.cartId) === String(cart._id) && String(s.code).trim().toLowerCase() === code;
  } catch {
    return false;
  }
}

export function setCheckoutExplicitCoupon(cartId, code) {
  if (!cartId || !code) return;
  sessionStorage.setItem(
    KEY,
    JSON.stringify({
      cartId: String(cartId),
      code: String(code).trim().toLowerCase(),
    })
  );
}

export function clearCheckoutExplicitCoupon() {
  sessionStorage.removeItem(KEY);
}
